import { c as _c } from "react/compiler-runtime";
import { toast } from '@systemeio/ui';
import { useGetNewsletterView } from 'modules/newsletters/single/hooks/use-get-newsletter-view';
import { useSendNewsletter } from 'modules/newsletters/single/hooks/use-send-newsletter';
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface';
import Confirmation from 'shared/components/confirmation-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export interface SaveAndSendNewsletterModalProps {
  onSave: () => Promise<void>;
  onClose: () => void;
  opened: boolean;
  newsletterId: NewsletterId;
  isTagsSelected: boolean;
  confirmationText: string;
}
export const SaveAndSendNewsletterModal = t0 => {
  const $ = _c(14);
  const {
    onClose,
    opened,
    onSave,
    newsletterId,
    isTagsSelected,
    confirmationText
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    fetcherSendNewsletter
  } = useSendNewsletter();
  let t1;
  if ($[0] !== newsletterId) {
    t1 = {
      newsletterId
    };
    $[0] = newsletterId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    mutateNewslettersData
  } = useGetNewsletterView(t1);
  let t2;
  if ($[2] !== fetcherSendNewsletter || $[3] !== isTagsSelected || $[4] !== mutateNewslettersData || $[5] !== newsletterId || $[6] !== onSave || $[7] !== t) {
    t2 = async () => {
      ;
      try {
        if (isTagsSelected) {
          await onSave();
          await fetcherSendNewsletter(newsletterId);
          await mutateNewslettersData(_temp, false);
        } else {
          toast.error(t("dashboard.newsletter_editor.select_tags_warning_message"));
        }
      } catch (t3) {
        const e = t3;
        throw e;
      }
    };
    $[2] = fetcherSendNewsletter;
    $[3] = isTagsSelected;
    $[4] = mutateNewslettersData;
    $[5] = newsletterId;
    $[6] = onSave;
    $[7] = t;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const onConfirm = t2;
  let t3;
  if ($[9] !== confirmationText || $[10] !== onClose || $[11] !== onConfirm || $[12] !== opened) {
    t3 = <><Confirmation opened={opened} onClose={onClose} onConfirm={onConfirm} confirmationText={confirmationText} /></>;
    $[9] = confirmationText;
    $[10] = onClose;
    $[11] = onConfirm;
    $[12] = opened;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};
function _temp(data) {
  return data && {
    ...data,
    sent: true
  };
}